import produce from 'immer';

// Import Constants
import {
    SEARCH_USERS_SUCCESS,
    GET_TASKS,
    GET_TASKS_SUCCESS,
    GET_TASKS_ERROR,
    GET_TASK,
    GET_TASK_SUCCESS,
    GET_TASK_ERROR,
    TASK_GROUP,
    TASK_GROUP_SUCCESS,
    TASK_GROUP_ERROR,
    SIDEBAR,
    ASSIGN_TASK,
    ASSIGN_TASK_SUCCESS,
    ASSIGN_TASK_ERROR,
    APPROVE_ENTITY,
    APPROVE_ENTITY_SUCCESS,
    APPROVE_ENTITY_ERROR,
    SIDEBAR_CREATE_PRICE,
    GET_APPLICANTS,
    GET_APPLICANTS_SUCCESS,
    GET_APPLICANTS_ERROR,
    CREATE_PRICE,
    CREATE_PRICE_SUCCESS,
    CREATE_PRICE_ERROR,
    JOB_COMMENT,
    JOB_COMMENT_SUCCESS,
    JOB_COMMENT_ERROR,
} from './constants';

export interface setState {
    error: any;
    loading: boolean;
    groupLoading: boolean;
    loadingTasks: boolean;
    loadingButton: boolean;
    sidebar: boolean;
    sidebarCreatePrice: boolean;
    users: Array<Object>;
    tasks: Array<Object>;
    task: {};
    groupTask: Array<Object>;
    applications: Array<Object>;
    loaderApplications: boolean;
    pageCountApplicants: number;
    currentPageApplicatants: number;
    sidebarLoader: boolean;
    jobComment: object | null;
    page: number;
    currentPage: number;
    pageCount: number;
}

export const initialState: setState = {
    error: null,
    loading: false,
    groupLoading: false,
    loadingTasks: false,
    loadingButton: false,
    sidebar: false,
    sidebarCreatePrice: false,
    users: [],
    tasks: [],
    task: {},
    groupTask: [],
    applications: [],
    loaderApplications: false,
    pageCountApplicants: 1,
    currentPageApplicatants: 1,
    sidebarLoader: false,
    jobComment: null,
    page: 1,
    currentPage: 1,
    pageCount: 1,
};

/* eslint-disable default-case, no-param-reassign */
const setTasksReducer = (state = initialState, action: any) =>
    produce(state, draft => {
        switch (action.type) {
            case SEARCH_USERS_SUCCESS:
                draft.users = action.response.data;
                break;
            case GET_TASKS:
                draft.tasks = [];
                draft.loadingTasks = true;
                break;   
            case GET_TASKS_SUCCESS:
                draft.loadingTasks = false;
                draft.currentPage = action?.response?.data?.meta?.current_page || 1;
                draft.pageCount = action?.response?.data?.meta?.last_page || 1;
                draft.tasks = action.response.data.data;
                break;
            case GET_TASKS_ERROR:    
                draft.loadingTasks = false;
                break;
            case GET_TASK:
                draft.task = {};
                draft.loading = true;
                break;   
            case GET_TASK_SUCCESS:
                draft.loading = false;
                draft.task = action.response.data;
                break;
            case GET_TASK_ERROR:    
                draft.loading = false;
                draft.error = action.error;
                break;
            case TASK_GROUP:
                draft.groupLoading = true;
                break;
            case TASK_GROUP_SUCCESS:
                draft.groupLoading = false;
                draft.groupTask = action.response.data;
                break;
            case TASK_GROUP_ERROR:    
                draft.groupLoading = false;
                break;
            case ASSIGN_TASK:
                draft.loadingButton = true;
                break;
            case ASSIGN_TASK_SUCCESS:
                draft.loadingButton = false;
                break;
            case ASSIGN_TASK_ERROR:    
                draft.loadingButton = false;
                draft.error = action.error;
                break;
            case APPROVE_ENTITY:
                draft.loadingButton = true;
                break;
            case APPROVE_ENTITY_SUCCESS:
                draft.loadingButton = false;
                break;
            case APPROVE_ENTITY_ERROR:    
                draft.loadingButton = false;
                draft.error = action.error;
                break;
            case SIDEBAR:
                draft.sidebar = action.open;
                break;
            case SIDEBAR_CREATE_PRICE:
                draft.sidebarCreatePrice = action.open;
                break;
            case GET_APPLICANTS:
                draft.applications = [];
                draft.loaderApplications = true;
                break;
            case GET_APPLICANTS_SUCCESS:
                draft.loaderApplications = false;
                draft.currentPageApplicatants = action?.response?.data?.meta?.current_page || 1;
                draft.pageCountApplicants = action?.response?.data?.meta?.last_page || 1;
                draft.applications = action.response.data.data;
                break;
            case GET_APPLICANTS_ERROR:
                draft.loaderApplications = false;
                break;
            case CREATE_PRICE:
                draft.loadingButton = true;
                break;
            case CREATE_PRICE_SUCCESS:
                draft.loadingButton = false;
                break;
            case CREATE_PRICE_ERROR:    
                draft.loadingButton = false;
                draft.error = action.error;
                break;

            case JOB_COMMENT:
                draft.sidebarLoader = true;
                break;
            case JOB_COMMENT_SUCCESS:
                draft.sidebarLoader = true;
                draft.jobComment = action.response.data
                break;
            case JOB_COMMENT_ERROR:    
                draft.sidebarLoader = true;
                draft.jobComment = null
                break;
        }
    });

export default setTasksReducer;